export const DEBUG = true;

//based on vuexy version 5.4
export const VERSION = "2.0.a";

// Backend API endpoints
export const API_BASE_URL = 'https://maya-dot-servi-forms.appspot.com/api/v2';
// export const API_BASE_URL = 'https://maya195-dot-servi-forms.appspot.com/api/v2';

export const REFRESH_TOKEN_URL = "/auth";

/**
 * Key for local storage.
 *
 * Set the key to use in local storage to hold persistant data. If logged in,
 * you can see this key by going to Chrome > dev tools > application tab,
 * then choosing "Local Storage" and "http://localhost:8080".
 *
 * @type {string}
 */

export const CLIENT_SECRET = "2sCl4nghzihZ93vVJiQD";
export const STORAGE_KEY = "calypso-vue";

// Add your API key here
export const googleMapsApiKey = "AIzaSyBznSkwCKZokVPAKNp50El5yDqjO2-q_lA";
export const libraries = ["awesome-lib"];

const ADMIN = ["ADMIN", "REGULAR_USER", "EXPRESS"];
const ADMINGENERAL = [...ADMIN, "GENERAL ADMINISTRATOR"];
const GOTU = [...ADMINGENERAL, "GOTU"];

export const ROLES = {
  ADMIN,
  GOTU,
  "GENERAL ADMINISTRATOR": ADMINGENERAL
};
